import { useMutation } from '@tanstack/react-query';

import { amendOrder, cancelOrder, newCancelOrder } from './requests';

export function useAmendOrder({ onSuccess }: { onSuccess?: () => void } = {}) {
  return useMutation({
    mutationFn: amendOrder,
    onSuccess,
  });
}

export function useCancelOrder({ onSuccess }: { onSuccess?: () => void } = {}) {
  return useMutation({
    mutationFn: cancelOrder,
    onSuccess,
  });
}

export function useNewCancelOrder({ onSuccess }: { onSuccess?: () => void } = {}) {
  return useMutation({
    mutationFn: newCancelOrder,
    onSuccess,
  });
}
